export default __webpack_public_path__ + "static/media/edit.87fa7ef7.svg";